import React from 'react'
import {
  RacingMarketType,
  RacingPropositionType,
} from '@core/Areas/VenueMode/Components/Racing/Data/types'
import {
  ContainerStyled,
  PropositionContainerStyled,
  PropositionDetailsStyled,
  PropositionDisabledTypeStyled,
  PropositionExtraInfoStyled,
  PropositionExtraRulesContainerStyled,
} from '@core/Areas/VenueMode/Components/Racing/RacingProposition.styles'
import { WinPlaceSelection } from '@core/Components/PriceChangeDisplay'
import { Icon } from '@mobi/component-library/Common/V2'
import { Tray } from '@mobi/component-library/Overlays/Tray'
import { RacingTermsAndConditions } from '@core/Areas/VenueMode/Components/Racing/RacingTermsAndConditions'

export interface VenueModeRacingPropositionProps {
  proposition: RacingPropositionType
  market: RacingMarketType
  selectedItem: RacingPropositionType | null
  onSelectedItemChanged: (proposition: RacingPropositionType) => void
}

export const RacingProposition: React.FC<VenueModeRacingPropositionProps> = ({
  proposition,
  market,
  selectedItem,
  onSelectedItemChanged,
}) => {
  const [isTermsConditionsVisible, setIsTermsConditionsVisible] = React.useState(false)

  const isDisabled = proposition.isScratched || proposition.isSuspended
  const disabledText = isDisabled ? (proposition.isScratched ? 'Scratched' : 'Suspended') : null
  return (
    <ContainerStyled>
      <PropositionContainerStyled>
        <PropositionDetailsStyled isDisabled={isDisabled}>
          {proposition.description}
        </PropositionDetailsStyled>

        {isDisabled ? (
          <PropositionDisabledTypeStyled>{disabledText}</PropositionDisabledTypeStyled>
        ) : (
          market.extraRules && (
            <PropositionExtraRulesContainerStyled onClick={() => setIsTermsConditionsVisible(true)}>
              <Icon name='LineInfoCircle' size='1.2rem' />
              {!isDisabled && (
                <PropositionExtraInfoStyled>{market.extraRulesSummary}</PropositionExtraInfoStyled>
              )}
            </PropositionExtraRulesContainerStyled>
          )
        )}
      </PropositionContainerStyled>

      <WinPlaceSelection
        isVisible={true}
        isDisabled={isDisabled}
        isFavourite={false}
        isSelected={selectedItem?.sequence == proposition.sequence}
        onClick={e => {
          e.stopPropagation()
          onSelectedItemChanged(proposition)
        }}
        priceWin={proposition.winReturn.toFixed(2)}
        pricePlace={proposition.placeReturn?.toFixed(2) ?? ''}
        starterNumber={0}
        centerContent={true}
      />

      <Tray
        isOpen={isTermsConditionsVisible}
        headerTitle='T&Cs'
        onDismiss={() => setIsTermsConditionsVisible(false)}
        trayStyle={{ maxHeight: '70vh' }}
      >
        <RacingTermsAndConditions market={market} />
      </Tray>
    </ContainerStyled>
  )
}
